export default __webpack_public_path__ + "static/media/back-icon.7e742b02.svg";